import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import TopBar from './components/TopBar/TopBar';
import Navbar from './components/Navbar/Navbar';
import Hero from './components/Hero/Hero';
import FeatureCards from './components/Features/FeatureCards';
import About from './components/About/About';
import Services from './components/Services/Services';
import Gallery from './components/Gallery/Gallery';
import Testimonials from './components/Testimonials/Testimonials';
import CallToAction from './components/CTA/CallToAction';
import Footer from './components/Footer/Footer';
import FloatingWhatsApp from './components/FloatingWhatsApp';
import ScrollToTop from './components/ScrollToTop';
import SEO from './components/SEO/SEO';

// New Pages
import AboutPage from './pages/AboutPage';
import TreatmentsPage from './pages/TreatmentsPage';
import GalleryPage from './pages/GalleryPage';

// Homepage Component
const Home = () => (
  <>
    <SEO
      title="Home"
      description="Welcome to Smile Care Dental Surgery at www.iimplants.lk. We provide advanced dental implants and comprehensive dental care in Sri Lanka."
      url="/"
    />
    <Navbar />
    <Hero />
    <FeatureCards />
    <About />
    <Services />
    <Gallery />
    <Testimonials />
    <CallToAction />
    <Footer />
    <FloatingWhatsApp />
  </>
);

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="relative w-full font-body transition-colors duration-300">
        <TopBar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about-us" element={<AboutPage />} />
          <Route path="/treatments" element={<TreatmentsPage />} />
          <Route path="/gallery-page" element={<GalleryPage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;

